import React from "react";
import { Streamdown } from "streamdown";

import { IgTypography } from "@intelligems/ig-theme";

type ReasoningMarkdownProps = {
  disableResponseWordByWordLoading?: boolean;
  text: string;
};
export const ReasoningMarkdown = ({
  text,
  disableResponseWordByWordLoading,
}: ReasoningMarkdownProps) => {
  return (
    <IgTypography
      variant="body2"
      sx={{
        fontStyle: "italic",
        color: "text.secondary",
        whiteSpace: "pre-wrap",
      }}
    >
      <Streamdown
        className="ai-chat-text"
        mode={disableResponseWordByWordLoading ? "static" : "streaming"}
      >
        {text}
      </Streamdown>
    </IgTypography>
  );
};
